export default __webpack_public_path__ + "static/media/q12_step4.d186d823.png";